export const contentCRM = [
  {
    id: 1,
    title: " Create CRM",
    link: "create-crm",
    listing: [
      {
        id: "0",
        title: "How to create CRM in anydone?",
        target: "how-to-create-crm",
      },
      {
        id: "1",
        title: "Managing Messages and Priorities in anydone CRM",
        target: "managing-messages",
      },
      {
        id: "2",
        title: "How to Change Message Priority",
        target: "how-to-change-message",
      },
      {
        id: "3",
        title: "Managing Spam Messages",
        target: "managing-spam-messages",
      },
      {
        id: "4",
        title: "How to Mark a Message as Not Spam",
        target: "how-to-mark-message-as-not-spam",
      },
    ],
  },
  {
    id: 2,
    title: "Getting Started with CRM",
    link: "anydone-crm-ai-agent-platform",
    listing: [
      {
        id: "0",
        title: "Getting started with Anydone Automated CRM",
        target: "getting-started-with-crm",
      },
      {
        id: "1",
        title: "Managing the CRM",
        target: "managing-crm",
      },
      {
        id: "2",
        title: "Who is an Agent in anydone CRM? ",
        target: "who-is-an-agent",
      },
      {
        id: "3",
        title: "How to Add a CRM Agent?",
        target: "how-to-add-crm",
      },
      {
        id: "4",
        title: "What are CRM Roles ?",
        target: "crm-roles",
      },
      {
        id: "5",
        title: "What is a Source in anydone CRM?",
        target: "what-is-source-in-anydone",
      },
    ],
  },
  {
    id: 3,
    title: "Managing CRM",
    link: "managing-crm",
    listing: [
      {
        id: "0",
        title: "How to link a folder in anydone CRM?",
        target: "how-to-link-folder-in-anydone",
      },
      {
        id: "1",
        title: "Understanding anydone CRM Leads",
        target: "understanding-anydone-crm",
      },
      {
        id: "2",
        title: "Managing CRM Contact List",
        target: "managing-crm-contact",
      },
      {
        id: "3",
        title: "Managing Customer in CRM",
        target: "managing-customer",
      },
      {
        id: "4",
        title: "What is Autopilot in anydone CRM?",
        target: "autopilot-crm",
      },
    ],
  },

  // {
  //   id: 4,
  //   title: " Automation Tools(AI)",
  //   link: "ai-agent",
  //   listing: [
  //     {
  //       id: "0",
  //       title: "Ticket Create",
  //       target: "how-to-build-auto-tickets-create",
  //     },
  //     {
  //       id: "1",
  //       title: "Text to Speech",
  //       target:"how-to-create-text-to-speech"
  //     },
  //     {
  //       id: "2",
  //       title: "Speech to Text",
  //       target:"how-to-create-speech-to-text"
  //     },
  //     {
  //       id: "3",
  //       title: "OCR",
  //       target:"how-to-create-ocr"
  //     },
  //     {
  //       id: "4",
  //       title: "Grammar Check",
  //       target:"how-to-create-grammar-check"
  //     },
  //     {
  //       id: "5",
  //       title: "Translation",
  //       target:"how-to-create-translation"
  //     },
  //     {
  //       id: "6",
  //       title: "Text Summarization",
  //       target:"how-to-create-text-summarization"
  //     },
  //     {
  //       id: "7",
  //       title: "Object Detection",
  //       target:"how-to-create-object-detection"
  //     },
  //     {
  //       id: "8",
  //       title: "Face Detection",
  //       target:"how-to-create-face-detection"
  //     },
  //     {
  //       id: "9",
  //       title: "Face Recognition",
  //       target:"how-to-create-face-recognition"
  //     },
  //     {
  //       id: "10",
  //       title: "Image comparison",
  //       target:"how-to-create-image-comparision"
  //     },
  //     {
  //       id: "11",
  //       title: "Image generation",
  //       target:"how-to-create-image-generation"
  //     },
  //     {
  //       id: "12",
  //       title:"Image Understanding",
  //       target:"how-to-create-image-comparision"
  //     },
  //     {
  //       id: "13",
  //       title:"Text Generation",
  //       target:"how-to-create-text-generation"
  //     },
  //     {
  //       id: "14",
  //       title:"Code Generation",
  //       target:"how-to-create-code-generation"
  //     },
  //     {
  //       id: "15",
  //       title:"API",
  //       target:"how-to-create-api"
  //     },
  //     {
  //       id: "16",
  //       title:"Lookup",
  //       target:"how-to-create-lookup"
  //     },
  //     {
  //       id: "17",
  //       title:"WASM",
  //       target:"how-to-create-webassembly"
  //     },
  //     {
  //       id: "18",
  //       title:"IR",
  //       target:"how-to-create-information-retrieval"
  //     },

  //   ],
  // },
  // {
  //   id: 5,
  //   title: "Automation  Tool (Process) ",
  //   link: "anydone-app",
  //   listing: [
  //     {
  //       id: "0",
  //       title: "Anydone",
  //     },
  //     {
  //       id: "1",
  //       title: "Chat Plugin",
  //     },
  //     {
  //       id: "2",
  //       title: "Live Capture",
  //     },
  //     {
  //       id: "3",
  //       title: "Webhook",
  //     },
  //     {
  //       id: "4",
  //       title: "Mail",
  //     },
  //     {
  //       id: "5",
  //       title: "Slack",
  //     },
  //   ],
  // },
];
